import * as THREE from 'three';

import config from './config'

const renderer = new THREE.WebGLRenderer({  antialias: false, alpha: true });

renderer.setPixelRatio(config.devicePixelRatio);

renderer.setClearColor(0xffffff, 0);

export default renderer;



// WEBPACK FOOTER //
// ./src/scripts/Trail/renderer.js